import React from 'react';
import Modal from '@mui/material/Modal';
import { Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BrokenRobotIcon from "../assets/images/finchatGPT/broken-robot-icon.png"

export default function LimitModal({ open, setOpen, onUpgrade }: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onUpgrade: () => void
}) {
  const handleClose = () => setOpen(false);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="limit-modal"
    >
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-4">
          {/* top section */}
          <div className='flex flex-col items-center justify-center relative mb-2'>
            <img src={BrokenRobotIcon} alt="broken-robot-icon" className='w-[80px] h-[80px] my-5' />
            <h3 className='text-[#1C1C1E] font-inter text-[24px] font-semibold leading-[24px]'>
              Hello,
            </h3>
            <IconButton onClick={handleClose} className='!absolute top-0 right-0'>
              <CloseIcon fontSize="small"/>
            </IconButton>
          </div>
          {/* text area */}
          <div>
            <p className='text-[#A3A3A3] text-[14px] text-center mb-5 leading-[18px]'>
              We noticed that you reached the limit for your account. Please upgrade your plan to ensure you can
              continue
              using TradeGPT without interruption.
            </p>
          </div>
          {/* upgrade button */}
          <div className='flex justify-center'>
            <Button
              sx={{
                padding: '8px 24px',
                borderRadius: '6px',
              }}
              onClick={onUpgrade}
              className="!text-white font-inter !text-[16px] !normal-case !bg-[#1C1C1E]"
            >
              Upgrade Now
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
